import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-solicitante-informado-correo',
  templateUrl: './solicitante-informado-correo.component.html',
  styleUrls: ['./solicitante-informado-correo.component.scss'],
})
export class SolicitanteInformadoCorreoComponent implements OnInit {
  tableValues: any[] = [];

  form: FormGroup;
  constructor(public fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      fecha_realizacion: [false, [Validators.required]],
      informado_correo: [false, [Validators.required]],
      email_usado: ['', [Validators.required, Validators.email]],
    });
  }
}
